import React from 'react';
import { OccupancyRankingSlot, ReservationTypeOccupancyRanking } from '../../types/business-metrics';
import { MetricsList } from '../MetricsList/MetricsList';
import { capitalize } from '../../utils/textUtils';
import './ReservationTypeOccupancy.scss';

const getTitle = (
  type: 'emptiest' | 'fullest',
  reservationTypeOccupancy: ReservationTypeOccupancyRanking,
  numberOfBranches: number,
) => {
  const typeText = type === 'emptiest' ? 'Horas más vacías' : 'Horas más llenas';
  if (numberOfBranches === 1) return `${typeText} - ${capitalize(reservationTypeOccupancy.reservationTypeName)}`;
  return `${typeText} - ${capitalize(reservationTypeOccupancy.reservationTypeName)} (${capitalize(
    reservationTypeOccupancy.branchName,
  )})`;
};

interface Props {
  occupancyRanking: ReservationTypeOccupancyRanking[];
}

export const ReservationTypeOccupancy = ({ occupancyRanking }: Props) => {
  const numberOfBranches = occupancyRanking.length;

  const renderListItem = (item: OccupancyRankingSlot) => (
    <div className='occupancy-item'>
      <div className='time-slot'>
        <i className='pi pi-clock'></i>
        <span>{item.label}</span>
      </div>
      <div className='occupancy-value'>
        <span>{item.averageOccupancy}</span>
      </div>
    </div>
  );

  return occupancyRanking.map((reservationTypeOccupancy) => (
    <React.Fragment key={`${reservationTypeOccupancy.reservationTypeName}-${reservationTypeOccupancy.branchName}`}>
      <MetricsList
        isEmpty={reservationTypeOccupancy.emptiestSlots.length === 0}
        key={`${reservationTypeOccupancy.reservationTypeName}-${reservationTypeOccupancy.branchName}-emptiest`}
        title={getTitle('emptiest', reservationTypeOccupancy, numberOfBranches)}
        items={reservationTypeOccupancy.emptiestSlots}
        renderItem={renderListItem}
      />
      <MetricsList
        isEmpty={reservationTypeOccupancy.fullestSlots.length === 0}
        key={`${reservationTypeOccupancy.reservationTypeName}-${reservationTypeOccupancy.branchName}-fullest`}
        title={getTitle('fullest', reservationTypeOccupancy, numberOfBranches)}
        items={reservationTypeOccupancy.fullestSlots}
        renderItem={renderListItem}
      />
    </React.Fragment>
  ));
};
